import { fromJS, Map } from "immutable";
import * as CONST from "actions/action_constants";
import _map from "lodash/map";
import _forEach from "lodash/forEach";

const installationManager = (state = Map({}), action) => {
  const { installationManager } = action;
  switch (action.type) {
    case CONST.APP_INIT_SUCCESS:
      return state.merge(fromJS(installationManager));
    case CONST.INSTALLATION_FETCH_SUCCESS:
    case CONST.INSTALLATION_FETCH_ERROR:
      return state.set("uptimeCheckTick", Date.now());
    default:
      return state;
  }
};

export default installationManager;
